<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="mb-5">
      <p-breadcrumb [model]="breadcrumbItems" [home]="home"></p-breadcrumb>
    </div>
  </div>

  <div class="col-12">
    @if(appName !== "Caser MIMAvet") {
    <div class="card shadow-2">
      <p-button label="Añadir Clínica" (click)="add()" icon="pi pi-plus" onKeyPress="" />
    </div>
    }
    <div class="card shadow-2">
      <clinic-table [data]="clinics$ | async" />
    </div>
  </div>
</div>

<p-dialog
  header="Crear Clínica"
  [(visible)]="viewModal"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '30vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="content">
    <form class="p-fluid py-2" [formGroup]="form">
      <div class="field">
        <p-fileUpload
          accept="image/png, image/jpeg"
          chooseLabel="Seleccionar imagen"
          chooseIcon="pi pi-upload"
          [customUpload]="true"
          [maxFileSize]="5000000"
          (uploadHandler)="onUpload($event)"
          [auto]="true"
        >
          <ng-template pTemplate="file">
            @if(selectedFile && previewUrl) {
            <p-image
              [src]="previewUrl"
              alt="Image"
              width="150"
              styleClass="flex justify-content-center"
            />

            }
          </ng-template>
        </p-fileUpload>
        @if (this.form.controls.fileImage.touched && this.form.controls.fileImage.dirty &&
        this.form.controls.fileImage.invalid) {
        <small class="p-error">Imagen inválida</small>
        }
      </div>

      <div class="field">
        <label class="block" for="color">Color</label>
        <p-colorPicker formControlName="color" id="color" />
      </div>

      <div class="field">
        <span class="p-float-label">
          <input id="name" type="text" pInputText formControlName="name" />
          <label for="name">Nombre</label>
        </span>
        @if (this.form.controls.name.touched && this.form.controls.name.dirty &&
        this.form.controls.name.invalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>

      <div class="field">
        <span class="block mb-1">Teléfono</span>
        <ngx-intl-tel-input
          [cssClass]="'p-inputtext p-component p-element min-w-full'"
          [onlyCountries]="onlyCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="false"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.Spain"
          [maxLength]="15"
          [phoneValidation]="true"
          [separateDialCode]="true"
          [numberFormat]="PhoneNumberFormat.National"
          name="phone"
          formControlName="phone"
          id="phoneNumber"
        >
        </ngx-intl-tel-input>

        @if (this.form.controls.phone.touched && this.form.controls.phone.dirty &&
        this.form.controls.phone.invalid) {
        <small class="p-error block">Ingresa un número de teléfono válido</small>
        }
      </div>

      <div class="field">
        <span class="p-float-label">
          <input id="privacyLink" type="text" pInputText formControlName="privacyLink" />
          <label for="inputtext">Link de privacidad</label>
        </span>
        @if (this.form.controls.privacyLink.touched && this.form.controls.privacyLink.dirty &&
        this.form.controls.privacyLink.invalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      [loading]="loading"
      icon="pi pi-check"
      label="Guardar"
      onKeyPress=""
      (click)="onSubmit()"
    />
  </ng-template>
</p-dialog>
